import { createRouter } from '@tanstack/react-router'
import { authLayoutOnlyGuestRoute, authLayoutRoute, guestLayoutRoute, mainLayoutRoute } from 'layouts/routes'
import { contactCreateRoute, contactDetailRoute, contactDetailUpdateRoute, contactRoute } from 'modules/contact/routes'
import { customerCreateRoute, customerDetailRoute, customerRoute } from 'modules/customer/routes'
import { authRoute } from 'modules/login/routes'
import {
  orderCopyRoute,
  orderCreateRoute,
  orderCreateYarcheRoute,
  orderDetailRoute,
  orderGuestCreateRoute,
  orderGuestRedirectCreateRoute,
  orderGuestRoute,
  orderRoute,
  orderYarcheGuestCreateRoute,
  orderYarcheGuestRoute
} from 'modules/order/routes'
import { orderRedirectRoute } from 'modules/order/routes/OrderRedirectRoute'
import { profileInfoRoute } from 'modules/profile/routes'
import { notFoundRoute, route403, route404, route500, techWorksRoute } from 'modules/techPages/routes'
import { authRedirectRoute } from 'src/modules/login/routes/AuthRedirectRoute'
import { orderYarcheGuestRedirectCreateRoute } from 'src/modules/order/routes/OrderYarcheGuestRedirectCreateRoute'
import { orderYarcheRedirectRoute } from 'src/modules/order/routes/OrderYarcheRedirectRoute'
import { orderYarcheCreate, orderYarcheGuestCreate } from 'utils/feature'

import { rootRoute } from './root-route'

const routeTree = rootRoute.addChildren([
  authLayoutOnlyGuestRoute.addChildren([authRoute]),
  authLayoutRoute.addChildren([route404, route403, route500, techWorksRoute]),
  guestLayoutRoute.addChildren([
    orderGuestRoute.addChildren([orderGuestCreateRoute]),
    ...(orderYarcheGuestCreate ? [orderYarcheGuestRoute.addChildren([orderYarcheGuestCreateRoute])] : [])
  ]),
  mainLayoutRoute.addChildren([
    contactRoute.addChildren([contactDetailRoute.addChildren([contactDetailUpdateRoute]), contactCreateRoute]),
    customerRoute.addChildren([customerDetailRoute, customerCreateRoute]),
    orderRoute.addChildren([
      orderDetailRoute,
      orderCreateRoute,
      orderCopyRoute,
      orderGuestRedirectCreateRoute,
      orderYarcheGuestRedirectCreateRoute,
      ...(orderYarcheCreate ? [orderCreateYarcheRoute] : [])
    ]),
    profileInfoRoute
  ]),
  notFoundRoute,
  authRedirectRoute,
  orderRedirectRoute,
  orderYarcheRedirectRoute
])

export const router = createRouter({
  routeTree,
  notFoundMode: 'root'
})
